const zeroDecimalRegex = /\.00/;

const removeZeroDecimalFromValue = (price: string) => price.replace(zeroDecimalRegex, '');

export const convertValueToFixedPoint = (value: number, fractionDigits = 2) =>
  parseFloat((value / 100).toFixed(fractionDigits));

const formatters: { [key: string]: Intl.NumberFormat } = {};

const getFormatter = (currencyCode: string) => {
  if (!formatters[String(currencyCode)]) {
    formatters[String(currencyCode)] = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currencyCode as string,
      useGrouping: false,
    });
  }

  return formatters[String(currencyCode)];
};

export const convertValueToPrice = (value: number, currencyCode = 'GBP', fractionDigits = 2) => {
  const formatter = getFormatter(currencyCode);
  const price = formatter.format(convertValueToFixedPoint(value, fractionDigits));

  return removeZeroDecimalFromValue(price);
};

export const getPriceWithSymbol = (value: number, currencyCode = 'GBP') => {
  const formatter = getFormatter(currencyCode);
  const price = formatter.format(value);

  return removeZeroDecimalFromValue(price);
};

export const getPricePerUnit = (price: number, unitOfMeasureValue: number) =>
  removeZeroDecimalFromValue(((price / unitOfMeasureValue) * 100).toFixed(2));

export const getUnitPriceString = (
  currencyCode: string,
  unitOfMeasureUnit: string,
  price: number,
  unitOfMeasureValue: number,
) => `${currencyCode}${getPricePerUnit(price, unitOfMeasureValue)} per 100${unitOfMeasureUnit}`;
